import BreadcrumbView from './breadcrumb-view'

export default BreadcrumbView
